import { Select } from 'antd';
import { useState } from 'react';
import { useFetch } from '../../../../hooks/useFetch/useFetch';
import { useAuth } from '../../../../store/AuthContext/AuthContext';
import { useLocation } from 'react-router-dom';
import { isProjectScopedPath } from '../../../../common/utils/headerScope';
import '../../../pages/common/header/MainHeader.scss';

export const GoogleAccounts = () => {
	const [googleAccounts, setGoogleAccounts] = useState<any>(null);
	const { project, groupAccount, setGroupAccount, projectGroup, setProjectGroup } = useAuth();
	const location = useLocation();
	const isProjectScope = isProjectScopedPath(location.pathname);

	const handleGroupChange = (selectedGroupId: string, currentAccountsList = googleAccounts) => {
		if (!selectedGroupId) return;

		const matchedAccount = currentAccountsList?.find((account: any) => account.id === selectedGroupId);
		const groupName = matchedAccount ? matchedAccount.value : '';

		// Evita re-renders y fetches si el valor efectivo no cambia
		const sameGroupAccount = groupAccount === selectedGroupId;
		const sameProjectGroup =
			projectGroup?.project === project &&
			projectGroup?.group === selectedGroupId &&
			projectGroup?.groupName === groupName;

		if (!sameGroupAccount) {
			setGroupAccount(selectedGroupId);
		}

		if (!sameProjectGroup) {
			setProjectGroup({
				project,
				group: selectedGroupId,
				groupName,
			});
		}
	};

	const { isLoading } = useFetch(
		`${process.env.REACT_APP_API}/users/principal/projects/` + project + '/platform/google/accounts',
		{},
		[],
		(data) => {
			setGoogleAccounts(data.groupList);
			// Una sola sincronización de grupo + projectGroup
			handleGroupChange(data.defaultValue, data.groupList);
		}
	);

	if (isProjectScope) {
		return (
			<div className='header-scope-select header-scope-select--na'>
				<div className='header-scope-select__na-value'>
					No aplica en esta pantalla
				</div>
				<small className='header-scope-select__label'>
					Grupo de Google
				</small>
			</div>
		);
	}

	const selectedAccount = googleAccounts?.find((account: any) => account.id === groupAccount);
	const isAllGroups =
		selectedAccount?.value === 'Todos los Grupos' ||
		projectGroup?.groupName === 'Todos los Grupos';

	return (
		<div className={`header-scope-select header-scope-select--active${isAllGroups ? ' header-scope-select--all-groups' : ''}`}>
			<Select
				onChange={(value) => handleGroupChange(value)}
				loading={isLoading}
				value={groupAccount}
				bordered={false}
				popupClassName="google-accounts-dropdown"
				style={{
					minWidth: '180px',
					textAlign: 'right',
					fontWeight: 700,
					borderRadius: '10px',
					cursor: 'pointer',
				}}
			>
				{googleAccounts?.map((account: any) => {
					const esElPrimeroTodos = account.value === 'Todos los Grupos';
					let optionStyle: React.CSSProperties = {};

					if (esElPrimeroTodos) {
						optionStyle = {
							borderBottom: '1px solid #e2e8f0',
							paddingBottom: '12px',
							marginTop: '4px',
							marginBottom: '8px',
							position: 'sticky',
							top: 0,
							zIndex: 10,
							background: '#ffffff',
						};
					}

					const hasLocations = Number(account.numberOfLocations) > 0;
					const textColor = esElPrimeroTodos ? '#0f172a' : 'black';
					const badgeColor = hasLocations ? '#0f172a' : '#94a3b8';

					return (
						<Select.Option key={account.id} value={account.id} style={optionStyle}>
							<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
								<span style={{ color: textColor }}>{account.value}</span>
								<small style={{ color: badgeColor, marginLeft: '3px' }}>
									{`(${account.numberOfLocations ?? 0})`}
								</small>
							</div>
						</Select.Option>
					);
				})}
			</Select>
			<small className='header-scope-select__label'>
				Grupo de Google
			</small>
		</div>
	);
};
